import apiClient from 'hub-http/clients/apiClient';
const baseUrl = '/contentpermissions/v1/permissions';
export const fetchPermissionsForContent = ({
  objectId,
  objectType
}) => apiClient.get(`${baseUrl}/default`, {
  query: {
    objectId,
    objectType
  }
}).then(({
  private: isPrivate,
  visibleToAll,
  permissions: {
    TEAM,
    USER
  }
}) => {
  return {
    private: isPrivate,
    visibleToAll,
    permissions: {
      TEAM: TEAM || [],
      USER: USER || []
    }
  };
});
export const saveContentPermissions = ({
  objectId,
  objectType,
  selectedTeams,
  selectedUsers,
  visibleToAll,
  private: isPrivate
}) => apiClient.put(baseUrl, {
  data: {
    objectType,
    objectIds: [objectId],
    permissions: {
      TEAM: selectedTeams,
      USER: selectedUsers
    },
    visibleToAll,
    private: isPrivate
  }
});